import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';

declare const window: any;

export const customerFeedAPI = createApi({
    reducerPath: 'customerFeedAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_FEED_CUSTOMER_API ?? "https://npr-feed-customer.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Discount'],
    endpoints: (builder) => ({
        getCustomerFeedInfo: builder.query({
            query: ({customerHashCode}) => ({
                url :  `${customerHashCode}/customerInformation`,
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try{
                    const {data} = await queryFulfilled;
                    return data;
                }
                catch(error){
                console.log(error);
                   dispatch(onErrorHandler({operation: "Get Customer Feed Info With Hash Code", err: JSON.stringify(error), errMsg: 'Error: while fetching customer feed info', api: '/{customerHash}/customerInformation'}));
                }
            },
        }),
    }),
})

export const {useGetCustomerFeedInfoQuery} = customerFeedAPI;